/**
 * Foundation · Review — modello puro della revisione "dato attuale → nuovo" riga per riga.
 * kind: new | conflict | same | protected. Decisioni: update | keep | skip.
 * Nessuna modifica a un dato esistente senza scelta esplicita: i conflitti partono da "keep".
 */
export const REVIEW_DECISIONS = Object.freeze({
  update: "Aggiorna",
  keep: "Mantieni",
  skip: "Salta",
});

export const decisionsFor = (kind) => (kind === "conflict" ? ["keep", "update", "skip"] : kind === "new" ? ["update", "skip"] : []);

export const automaticDecisions = (rows) => Object.fromEntries(rows.map((r) => [r.key, r.default_decision]));

export const updateAllFilled = (rows, decisions) =>
  ({ ...decisions, ...Object.fromEntries(rows.filter((r) => r.kind === "conflict").map((r) => [r.key, "update"])) });

export function countDecisions(rows, decisions) {
  const out = { update: 0, keep: 0, skip: 0, protected: 0, same: 0 };
  rows.forEach((r) => {
    if (r.kind === "protected") out.protected += 1;
    else if (r.kind === "same") out.same += 1;
    else out[decisions[r.key] || r.default_decision] += 1;
  });
  return out;
}
